// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--wPTHv","link":"link--IRNo8","icon":"icon--jSCt5","small":"small--LgpJE","medium":"medium--NfMug","large":"large--ZY_XS","fadeSlideUp":"fadeSlideUp--Sd5yA"};